export const PAYMENT_TERMS = [
  { code: "BB 30 DF", label: "Bonifico 30 giorni data fattura" },
  { code: "BB 30 FM", label: "Bonifico 30 giorni fine mese" },
  { code: "BB 30 FM +10", label: "Bonifico 30 giorni fine mese + 10" },
  { code: "BB 30 FM +15", label: "Bonifico 30 giorni fine mese + 15" },
  { code: "BB 60 FM", label: "Bonifico 60 giorni fine mese" },
  { code: "BB 60 FM +10", label: "Bonifico 60 giorni fine mese + 10" },
  { code: "BB 60 FM +15", label: "Bonifico 60 giorni fine mese + 15" },
  { code: "BB 90 FM", label: "Bonifico 90 giorni fine mese" },
  { code: "BB 90 FM +10", label: "Bonifico 90 giorni fine mese + 10" },
  { code: "BB 90 FM +15", label: "Bonifico 90 giorni fine mese + 15" },
  { code: "RB 30 FM", label: "Ri.Ba. 30 giorni fine mese" },
  { code: "RB 30 FM +10", label: "Ri.Ba. 30 giorni fine mese + 10" },
  { code: "RB 30 FM +15", label: "Ri.Ba. 30 giorni fine mese + 15" },
  { code: "RB 60 FM", label: "Ri.Ba. 60 giorni fine mese" },
  { code: "RB 60 FM +10", label: "Ri.Ba. 60 giorni fine mese + 10" },
  { code: "RB 60 FM +15", label: "Ri.Ba. 60 giorni fine mese + 15" },
  { code: "RB 90 FM", label: "Ri.Ba. 90 giorni fine mese" },
  { code: "RB 90 FM +10", label: "Ri.Ba. 90 giorni fine mese + 10" },
  { code: "RB 90 FM +15", label: "Ri.Ba. 90 giorni fine mese + 15" },
];

export const paymentTermLabel = (code) => {
  if (!code) return "";
  const t = PAYMENT_TERMS.find((x) => x.code === code);
  return t ? `${t.code} — ${t.label}` : code;
};
